module.exports = __webpack_public_path__ + "components/flag/static/square/sx-019b978b8ee30f908ff254d4080d6432.svg";